export default function sliceConfigFormat(
  firstOccurrence: number,
  configFormat: string,
  lastOccurrence: number
) {
  if (firstOccurrence === 0) {
    configFormat = configFormat.slice(lastOccurrence + 2, configFormat.length);
  } else if (lastOccurrence === configFormat.length - 1) {
    configFormat = configFormat.slice(0, firstOccurrence - 1);
  }
  return configFormat;
}
